if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const openerMediaId = this.openedBy && this.openedBy.getAttribute('data-media-id');
        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        if (!allMedia.length) return;

        let activeMedia =
          (openerMediaId &&
            this.querySelector(`[data-media-id="${openerMediaId}"]`)) ||
          allMedia[0];
        if (!activeMedia) return;

        allMedia.forEach((element) => {
          element.classList.remove('active');
        });

        const activeMediaTemplate = activeMedia?.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        // Scroll the modal's internal content so the active media is in view,
        // without scrolling the entire page.
        const container = this.querySelector('[role="document"]');
        if (container && typeof activeMedia.offsetTop === 'number') {
          const containerTop = container.getBoundingClientRect().top + window.scrollY;
          const targetTop = activeMedia.getBoundingClientRect().top + window.scrollY;
          const offset = targetTop - containerTop;
          container.scrollTop = Math.max(0, offset - 16);
        }

        // Ensure videos and 3D models actually play when opened in the modal
        if (activeMediaContent) {
          const isDeferred =
            activeMedia.nodeName === 'DEFERRED-MEDIA' ||
            activeMedia.nodeName === 'PRODUCT-MODEL' ||
            activeMedia.classList.contains('deferred-media');
          if (isDeferred && typeof activeMedia.loadContent === 'function') {
            activeMedia.loadContent();
          }
        }
      }
    }
  );
}
